/* eslint-disable max-len */
import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "@teamprevent/common/healthSurveillance";

import * as questionIds from "./questionIds";

const medicalTypes = [
    MedicalTypeIds.SafetyCriticalWorker,
    MedicalTypeIds.GroupOneDriving,
    MedicalTypeIds.GroupTwoDriving,
    MedicalTypeIds.WorkAtHeight,
    MedicalTypeIds.WorkingConfinedSpaces,
    MedicalTypeIds.WearingRPE,
    MedicalTypeIds.WearingBreathingApparatus,
    MedicalTypeIds.WorkingThermalEnvironment,
    MedicalTypeIds.Offshore,
    MedicalTypeIds.Airside,
    MedicalTypeIds.OtherFitnessToWork,
    MedicalTypeIds.AmzPitPupMedical
];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../consultation";` which is in a data structure suitable for use with custom medicals
 */
export const urinalysisQuestions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.UrinalysisUnableToCarryOut,
        questionText: "Unable to carry out medical",
        medicalTypes
    },
    {
        id: questionIds.UrinalysisUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
        medicalTypes
    },
    {
        id: questionIds.UrinalysisProtein,
        questionText: "Protein",
        medicalTypes
    },
    {
        id: questionIds.UrinalysisGlucose,
        questionText: "Glucose",
        medicalTypes
    },
    {
        id: questionIds.UrinalysisBlood,
        questionText: "Blood",
        medicalTypes
    },
    {
        id: questionIds.UrinalysisSelfReferralLetterIssued,
        questionText: "GP Self-Referral Letter issued?",
        medicalTypes
    }
];
/* eslint-enable max-len */
